import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router/router'
import store from './store/store'
import vuetify from '@/plugins/vuetify';
import ebusPlugin from '@/plugins/ebusPlugin';
import './filters/filters.js';
import './directives/enclosedtitle';
import Storage from 'vue-ls';
import {errorReport} from "@/util/globalErrorHandler";
import {globalErrorHandlerMixin} from "@/mixins/globalErrorHandlerMixin"; //https://github.com/RobinCK/vue-ls
// import VueFuse from 'vue-fuse'
// import VueMeta from 'vue-meta'
// import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';
// https://github.com/samjonesigd/vue-image-zoomer

// https://github.com/84436/keep-me-awake/blob/main/src/App.vue

Vue.config.productionTip = false

let lsOptions = {
  storage: 'memory' // storage name session, local, memory
};
// namespace: 'vuejs__', // key prefix
// name: 'ls', // name variable Vue.[ls] or this.[$ls],
try {
  if (typeof localStorage !== 'undefined') {
    console.log('localStorage is available');
    lsOptions.storage = 'local';
  }else{
    console.log('localStorage is NOT available');
  }
} catch (e) {
  console.log('catched error on localStorage');
}

// Vue.use(VueTelInputVuetify, {
//   vuetify,
// });

Vue.use(Storage, lsOptions);
// Vue.use(VueFuse);//"vue-fuse": "^2.2.1",
Vue.use(ebusPlugin);
// Vue.use(VueMeta);

// Register the mixin globally
Vue.mixin(globalErrorHandlerMixin);

// Set up global error handler
Vue.config.errorHandler = function (err, vm, info) {
  // console.error('Global errorHandler:', err);
  // console.error('Component causing error:', vm);
  // console.error('Error info:', info);
  console.error('ddddddddddd Global lifecycle errorHandler:', err);
  errorReport(err, vm, info)
};

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
